module.exports = __webpack_public_path__ + "static/one-pitch-at-a-time-601340e609ef5ed00680d2b351db0923.jpg";